import { render, staticRenderFns } from "./icon-chevron-down.vue?vue&type=template&id=90ca640c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90ca640c')) {
      api.createRecord('90ca640c', component.options)
    } else {
      api.reload('90ca640c', component.options)
    }
    module.hot.accept("./icon-chevron-down.vue?vue&type=template&id=90ca640c&", function () {
      api.rerender('90ca640c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/icons/icon-chevron-down.vue"
export default component.exports